import React from 'react';
import { CollapsibleDetailsSection } from '../../components';
import { TERMINAL_ORDER_DETAILS } from '@shared/data/mockTerminalsPanels';

interface OrderSectionProps {
  isExpanded: boolean;
  onToggle: () => void;
  isDetailView?: boolean;
  className?: string;
}

export const OrderSection = React.memo<OrderSectionProps>(({ isExpanded, onToggle, isDetailView = false, className }) => {
  const handleViewOrder = () => {
    console.log('View order clicked');
  };

  const actions = [
    {
      label: 'View Order',
      onClick: handleViewOrder
    }
  ];

  return (
    <CollapsibleDetailsSection
      title="Order"
      details={TERMINAL_ORDER_DETAILS}
      isExpanded={isExpanded}
      onToggle={onToggle}
      isDetailView={isDetailView}
      emptyMessage="No order details available"
      actions={actions}
      className={className}
    />
  );
});

OrderSection.displayName = 'OrderSection';
